import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/app/portfolio/components/PortfolioHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/app/portfolio/components/PortfolioInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/ui/AppImage.tsx");
